import { CaretRightOutlined, FileImageOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { layoutForCount } from './collageLayouts'
import type { ContentProjectCoverCandidate } from '../../../api'

interface ProjectCoverCollageProps {
  projectId: string
  candidates: ContentProjectCoverCandidate[]
}

function isVideoCandidate(candidate: ContentProjectCoverCandidate): boolean {
  if (candidate.is_video) return true
  const type = candidate.asset_type
  return type === 'video_task' || type === 'video_asset'
}

export default function ProjectCoverCollage({ candidates }: ProjectCoverCollageProps) {
  const { t } = useTranslation('contentProjects')
  const usable = candidates.filter((c) => Boolean(c.thumbnail_url))
  const layout = layoutForCount(usable.length)

  if (usable.length === 0) {
    return (
      <div className="cpg-cover cpg-cover--empty" aria-hidden="true">
        <div className="cpg-cover-empty-inner">
          <FileImageOutlined className="cpg-cover-empty-icon" />
          <span className="cpg-cover-empty-label">{t('cover.awaitingAssets')}</span>
        </div>
      </div>
    )
  }

  const slots = layout.slots.slice(0, usable.length)

  return (
    <div className={`cpg-cover cpg-cover--layout-${layout.id}`} data-layout={layout.id} aria-hidden="true">
      {slots.map((slot, i) => {
        const candidate = usable[i]
        const video = isVideoCandidate(candidate)
        return (
          <div key={`${layout.id}-${i}`} className={slot.className}>
            <img
              className="cpg-cover-img"
              src={candidate.thumbnail_url}
              alt=""
              loading="lazy"
              decoding="async"
              draggable={false}
            />
            {video ? (
              <span className="cpg-cover-video-badge" aria-hidden="true">
                <CaretRightOutlined />
              </span>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
